
export const MAX_ATTEMPTS = 10
